import { ALERTS,REMOVE_ALERTS } from "../action";


const AlertReducer = (state: any, action:any) => {
    switch(action.type){
        case ALERTS:
            return [...state, action.payload];
        case REMOVE_ALERTS:
            return state.filter((alert: { id: string; }) => alert.id !== action.payload)
        default:
            return state;
    }
}

export default AlertReducer;